import { getCardScore } from '../constants/scoring.js';
export function calculateRoundScore(hand) {
    return hand.reduce((sum, card) => sum + getCardScore(card), 0);
}
export function calculateRoundScores(players, winnerId) {
    if (!players.some(player => player.id === winnerId)) {
        throw new Error(`Cannot calculate round scores for unknown winner: ${winnerId}`);
    }
    const scores = {};
    let winnerPoints = 0;
    for (const player of players) {
        if (player.id === winnerId) {
            scores[player.id] = 0;
        }
        else {
            const handScore = calculateRoundScore(player.hand);
            winnerPoints += handScore;
            scores[player.id] = 0;
        }
    }
    scores[winnerId] = winnerPoints;
    return scores;
}
//# sourceMappingURL=scoring.js.map